import { c as _c } from "react/compiler-runtime";
import { ProfileActivityLog } from "@/entities/IProfile";
import { ProfileActivityLogType } from "@/enums";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import ProfileActivityLogBanner from "./items/ProfileActivityLogBanner";
import ProfileActivityLogClassification from "./items/ProfileActivityLogClassification";
import ProfileActivityLogContact from "./items/ProfileActivityLogContact";
import ProfileActivityLogGeneralStatement from "./items/ProfileActivityLogGeneralStatement";
import ProfileActivityLogHandle from "./items/ProfileActivityLogHandle";
import ProfileActivityLogNFTAccount from "./items/ProfileActivityLogNFTAccount";
import ProfileActivityLogPfp from "./items/ProfileActivityLogPfp";
import ProfileActivityLogProfileArchived from "./items/ProfileActivityLogProfileArchived";
import ProfileActivityLogProxy from "./items/ProfileActivityLogProxy";
import ProfileActivityLogProxyAction from "./items/ProfileActivityLogProxyAction";
import ProfileActivityLogProxyActionChange from "./items/ProfileActivityLogProxyActionChange";
import ProfileActivityLogProxyActionState from "./items/ProfileActivityLogProxyActionState";
import ProfileActivityLogRate from "./items/ProfileActivityLogRate";
import ProfileActivityLogSocialMedia from "./items/ProfileActivityLogSocialMedia";
import ProfileActivityLogSocialMediaVerificationPost from "./items/ProfileActivityLogSocialMediaVerificationPost";
export default function UserPageIdentityActivityLogItem(t0) {
  const $ = _c(34);
  const {
    log,
    user
  } = t0;
  const logType = log.type;
  switch (logType) {
    case ProfileActivityLogType.RATING_EDIT:
      {
        let t1;
        if ($[0] !== log || $[1] !== user) {
          t1 = <ProfileActivityLogRate log={log} user={user} />;
          $[0] = log;
          $[1] = user;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case ProfileActivityLogType.HANDLE_EDIT:
      {
        let t1;
        if ($[3] !== log) {
          t1 = <ProfileActivityLogHandle log={log} />;
          $[3] = log;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case ProfileActivityLogType.SOCIALS_EDIT:
      {
        let t1;
        if ($[5] !== log) {
          t1 = <ProfileActivityLogSocialMedia log={log} />;
          $[5] = log;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case ProfileActivityLogType.CONTACTS_EDIT:
      {
        let t1;
        if ($[7] !== log) {
          t1 = <ProfileActivityLogContact log={log} />;
          $[7] = log;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case ProfileActivityLogType.SOCIAL_VERIFICATION_POST_EDIT:
      {
        let t1;
        if ($[9] !== log) {
          t1 = <ProfileActivityLogSocialMediaVerificationPost log={log} />;
          $[9] = log;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
    case ProfileActivityLogType.CLASSIFICATION_EDIT:
      {
        let t1;
        if ($[11] !== log) {
          t1 = <ProfileActivityLogClassification log={log} />;
          $[11] = log;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
    case ProfileActivityLogType.BANNER_1_EDIT:
      {
        let t1;
        if ($[13] !== log) {
          t1 = <ProfileActivityLogBanner log={log} />;
          $[13] = log;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    case ProfileActivityLogType.BANNER_2_EDIT:
      {
        let t1;
        if ($[15] !== log) {
          t1 = <ProfileActivityLogBanner log={log} />;
          $[15] = log;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        return t1;
      }
    case ProfileActivityLogType.PFP_EDIT:
      {
        let t1;
        if ($[17] !== log) {
          t1 = <ProfileActivityLogPfp log={log} />;
          $[17] = log;
          $[18] = t1;
        } else {
          t1 = $[18];
        }
        return t1;
      }
    case ProfileActivityLogType.PROFILE_ARCHIVED:
      {
        let t1;
        if ($[19] !== log) {
          t1 = <ProfileActivityLogProfileArchived log={log} />;
          $[19] = log;
          $[20] = t1;
        } else {
          t1 = $[20];
        }
        return t1;
      }
    case ProfileActivityLogType.GENERAL_CIC_STATEMENT_EDIT:
      {
        let t1;
        if ($[21] !== log) {
          t1 = <ProfileActivityLogGeneralStatement log={log} />;
          $[21] = log;
          $[22] = t1;
        } else {
          t1 = $[22];
        }
        return t1;
      }
    case ProfileActivityLogType.NFT_ACCOUNTS_EDIT:
      {
        let t1;
        if ($[23] !== log) {
          t1 = <ProfileActivityLogNFTAccount log={log} />;
          $[23] = log;
          $[24] = t1;
        } else {
          t1 = $[24];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_CREATED:
      {
        let t1;
        if ($[25] !== log) {
          t1 = <ProfileActivityLogProxy log={log} />;
          $[25] = log;
          $[26] = t1;
        } else {
          t1 = $[26];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_CREATED:
      {
        let t1;
        if ($[27] !== log) {
          t1 = <ProfileActivityLogProxyAction log={log} />;
          $[27] = log;
          $[28] = t1;
        } else {
          t1 = $[28];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_STATE_CHANGED:
      {
        let t1;
        if ($[29] !== log) {
          t1 = <ProfileActivityLogProxyActionState log={log} />;
          $[29] = log;
          $[30] = t1;
        } else {
          t1 = $[30];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_CHANGED:
      {
        let t1;
        if ($[31] !== log) {
          t1 = <ProfileActivityLogProxyActionChange log={log} />;
          $[31] = log;
          $[32] = t1;
        } else {
          t1 = $[32];
        }
        return t1;
      }
    case ProfileActivityLogType.DROP_COMMENT:
    case ProfileActivityLogType.DROP_RATING_EDIT:
    case ProfileActivityLogType.DROP_CREATED:
    case ProfileActivityLogType.PROXY_DROP_RATING_EDIT:
      {
        let t1;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <></>;
          $[33] = t1;
        } else {
          t1 = $[33];
        }
        return t1;
      }
    default:
      {
        assertUnreachable(logType);
      }
  }
}